import React from 'react';

import BarPagesChart from '../components/BarPagesChart';



const categories = [
	{
		value: 1,
		label: '1',
		color: '#367be2',
	},
	{
		value: 2,
		label: '2',
		color: '#367be2',
	},
	{
		value: 3,
		label: '3',
		color: '#367be2',
	},
	{
		value: 4,
		label: '4',
		color: '#367be2',
	},
	{
		value: 5,
		label: '5',
		color: '#367be2',
	},
	{
		value: 6,
		label: '6',
		color: '#367be2',
	},
	{
		value: 7,
		label: '7',
		color: '#367be2',
	},
	{
		value: 8,
		label: '8',
		color: '#367be2',
	},
	{
		value: 9,
		label: '9',
		color: '#367be2',
	},
	{
		value: '10+',
		label: '10+',
		color: '#367be2',
	},
];



type Props = {
	data: Array<{
		count: number;
		percentage: number;
		value: string;
	}>;
};

const UrlDepthChart: React.FC<Props> = (props) => {
	const {
		data,
	} = props;

	const chartData = React.useMemo(
		() => {
			return categories.map((category) => {
				const item = data.find((item) => item.value === category.value);

				if (item) {
					return item;
				}

				return {
					count: 0,
					percentage: 0,
					value: category.value,
				};
			});
		},
		[
			data,
		]
	);

	return (
		<BarPagesChart
			categories={categories}
			data={chartData}
			name="url_depth"
		/>
	);
};



export default React.memo(UrlDepthChart);
